import ResultEventCollection from "@/collections/modus/ResultEventCollection";
import CustomerModel from "@/models/crm/CustomerModel";
import ModusServiceModel from "../ModusServiceModel";
import Submission from "../Submission";
import ResultDocumentCollection from "@/collections/modus/ResultDocumentCollection";
import Document from "@/models/document/DocumentModel";
import DocumentCollection from "@/collections/document/DocumentCollection";

export default class ResultModel extends ModusServiceModel {
  modelName() {
    return "results";
  }
  defaults() {
    return {
      id: null,
      laboratory_id: null,
      laboratory: null,
      customer: null,
      grower: null,
      type: null,
      field: null,
      received_from: null,
      received_at: null,
      headers: null,
      success: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      result_events: {}
    };
  }
  mutations() {
    return {
      id: val => this.nullStringMutator(val),
      laboratory_id: val => this.nullStringMutator(val),
      lab_submission_id: val => this.nullStringMutator(val),
      grower: val => this.nullStringMutator(val),
      type: val => this.nullStringMutator(val),
      field: val => this.nullStringMutator(val),
      received_from: val => this.nullStringMutator(val),
      received_at: val => this.nullStringMutator(val),
      headers: val => this.nullStringMutator(val),
      success: Boolean,
      created_at: val => this.nullStringMutator(val),
      updated_at: val => this.nullStringMutator(val),
      deleted_at: val => this.nullStringMutator(val)
    };
  }
  validation() {
    return {};
  }
  routes() {
    const base = `${process.env.VUE_APP_MODUS_REPOSITORY_URL}/api/v1/`;
    const routes = super.routes();

    routes.compiled = `${base}${this.modelName()}/{result_id}/compiled`;

    return routes;
  }
  getCustomer() {
    return this.getRelatedModel(CustomerModel, "customer");
  }
  getResultEvents() {
    return this.getRelatedCollection(
      new ResultEventCollection(),
      "result_events"
    );
  }
  getResultDocuments() {
    return this.getRelatedCollection(
      new ResultDocumentCollection(),
      "result_documents"
    );
  }
  getLaboratoryClient() {
    const collection = this.getResultEvents();

    if (collection.length) {
      const model = collection.first();

      return model ? model.getLaboratoryClient() : null;
    }
  }
  customerIdentifier() {
    const client = this.getLaboratoryClient();

    return client && client.customer_id ? client.customer_id : null;
  }
  clientName() {
    const client = this.getLaboratoryClient();

    return client && client.business ? client.business : null;
  }
  getLaboratoryClientContact() {
    const collection = this.getResultEvents();

    if (collection.length) {
      const model = collection.first();

      if (model) {
        return model.getLaboratoryClientContact();
      }
    }

    return null;
  }
  getLabSubmission() {
    const sub = new Submission({ id: this.lab_submission_id });

    sub.fetch();

    return sub;
  }
  getLaboratoryTestPackages() {
    const events = this.getResultEvents();

    return events.getLaboratoryTestPackages();
  }
  preload() {
    if (this._preload) {
      return new Promise(resolve => resolve);
    }

    return Promise.all([
      this.getResultEvents(),
      this.getResultDocuments()
    ]).then(() => {
      const p = [];

      this.getResultDocuments().each(r_document =>
        p.push(r_document.getDocument())
      );

      return Promise.all(p).then(results => {
        results.forEach(result => {
          if (result instanceof Document) {
            if (!this._documents) {
              this._documents = new DocumentCollection();
            }
            this._documents.add(result);
          }
        });
        this._preload = true;
      });
    });
  }
  compiled() {
    if (this._compiled) {
      return new Promise(resolve => resolve(this._compiled));
    }

    const config = {
      method: this.getMethod("fetch"),
      url: this.getURL(this.getRoute("compiled"), { result_id: this.id })
    };

    return this.createRequest(config)
      .send()
      .then(({ response }) => {
        if (response.status === 200) {
          return (this._compiled = response.data);
        }
      });
  }
  getLoadedDocuments() {
    return this._documents ? this._documents : new DocumentCollection();
  }
}
